module.exports = __webpack_public_path__ + "img/logo2026.73284d18.png";